import {mapActions, mapState} from 'vuex'
import * as types from '@/store/types'
import CookieHelper from '@/utils/cookie-helper'

export default {
    name: 'Home',
    computed: {
        ...mapState({
            menuItems: state => state.app.menuItems,
            queue: state => state.app.queue,
            phone: state => state.app.phone
        })
    },
    methods: {
        ...mapActions({
            guiTryInitSet: types.GUI.tryInit.set,
            appClientSet: types.APP.client.set,
            appServicingSet: types.APP.servicing.set,
            appQueueSet: types.APP.queue.set,
            appPhoneSet: types.APP.phone.set
        }),
        onSelect(item) {
            this.$service._setGuiLoading()
            this.appQueueSet(item.code)

            if (item.phoneRequired) {
                this.$pageManager.showPhone()
                this.$service._unsetGuiLoading()
            } else {
                this.$service.create(this.queue, this.phone).then((data) => {
                    CookieHelper.setClientId(this.$cookie, data.getId())
                    this.appClientSet(data)
                }).finally(() => {
                    this.$pageManager.showClient()
                    this.$service._unsetGuiLoading()
                })
            }
        }
    },
    data() {
        return {
            apiKey: null
        }
    },
    beforeMount() {
        this.appClientSet(null)
        this.appServicingSet(null)
        this.appQueueSet(null)
        this.appPhoneSet(null)
        CookieHelper.delClientId(this.$cookie)
        const urlParams = new URLSearchParams(window.location.search)
        this.apiKey = urlParams.get('key')
    }
}
